import { render } from "./ProgrammItem.vue?vue&type=template&id=4a61ed08"
import script from "./ProgrammItem.vue?vue&type=script&lang=js"
export * from "./ProgrammItem.vue?vue&type=script&lang=js"

import "./ProgrammItem.vue?vue&type=style&index=0&id=4a61ed08&lang=css"

import exportComponent from "/Users/mad/Business/156kr/Clients/ archive/kultursommer/kultursommer_web25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__